import { render, staticRenderFns } from "./VideoRequest.vue?vue&type=template&id=c1abcffa"
import script from "./VideoRequest.js?vue&type=script&lang=js&external"
export * from "./VideoRequest.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports